module.exports = __webpack_public_path__ + "img/home_header_bg-special.19177c0c.png";